import { EditorState, Transaction } from 'hubspot-prosemirror/pm/state';
import { Fragment, Node, Slice } from 'hubspot-prosemirror/pm/model';
import { getImageDimensions } from '../../draft-transplant/utils/libUtils';

export function isImageFile(file: File) {
  return /image\//.test(file.type);
}

export const DEFAULT_IMAGE_WIDTH = 400;

export function scaleImageSize(
  rawImageData: any,
  maxWidth: number = DEFAULT_IMAGE_WIDTH
) {
  if (rawImageData.width) {
    const scale =
      rawImageData.width < maxWidth ? 1 : maxWidth / rawImageData.width;
    return {
      ...rawImageData,
      width: rawImageData.width * scale,
      height: rawImageData.height ? rawImageData.height * scale : undefined,
    };
  } else {
    return {
      ...rawImageData,
      width: maxWidth,
      // height should default to auto, if an image doesn't have width it shouldnt have height
      height: undefined,
    };
  }
}

// Pre-condition: files contains valid image files
export function addTemporaryImageNodes(
  editorState: EditorState,
  dispatcher: (tr: Transaction) => void,
  files: Array<File>,
  fileOptions: {
    fileManagerAccess?: string;
    folderPath?: string;
    defaultImageWidth?: number;
  } = {}
) {
  const fragmentNodes: Array<Node> = [];
  const promises = files.map((file) => {
    const tempFileUrl = URL.createObjectURL(file);
    return getImageDimensions(tempFileUrl).then(
      ({ height, width }: { height: number; width: number }) => {
        const rawData = {
          height,
          isTemporary: true,
          src: tempFileUrl,
          uploadPercent: 10,
          width,
          originalDimensions: { width, height },
        };
        const scaledRawData = scaleImageSize(
          rawData,
          fileOptions.defaultImageWidth
        );
        const data = {
          ...scaledRawData,
          originalDimensions: { width, height },
        };
        const { schema } = editorState;
        const imageNode = schema.nodes.image.create({
          src: data.src,
          isTemporary: true,
          uploadPercent: 0,
          originalDimensions: data.originalDimensions,
          width: data.width,
          height: data.height,
          fileToUpload: file,
          fileManagerAccess: fileOptions.fileManagerAccess,
          folderPath: fileOptions.folderPath,
        });
        fragmentNodes.push(schema.nodes.paragraph.create(), imageNode);
      }
    );
  });
  return Promise.all(promises).then(() => {
    let tr = editorState.tr;
    tr = tr.replaceSelection(
      new Slice(
        Fragment.fromArray([
          ...fragmentNodes,
          editorState.schema.nodes.paragraph.create(),
        ]),
        0,
        0
      )
    );
    dispatcher(tr);
  });
}
